'use client';

import { HeroSection } from '@/components/landing/hero-section';
import { ServicesOverviewSection } from '@/components/landing/services-overview-section';
import { HowItWorksSection } from '@/components/landing/how-it-works-section';
import { AboutSection } from '@/components/landing/about-section';
import { UrlAnalyzerTool } from '@/components/url-analyzer-tool';
import { AllPackagesSection } from '@/components/landing/all-packages-section'; // Import the new section
import { FaqSection } from '@/components/landing/faq-section';
import CalendlyBadge from '@/components/CalendlyBadge';
import ContactFormPopup from '@/components/ContactFormPopup';

export default function Home() {
  return (
    <div className="w-full overflow-x-hidden">
      <CalendlyBadge
        url="https://calendly.com/3xerriestech/free-audit"
        color="#0069ff"
        textColor="#ffffff"
        openUrl="new_tab"
      />
      <section id="hero" className="w-full">
        <HeroSection />
      </section>

      <section id="about" className="w-full">
        <AboutSection />
      </section>

      <section id="services" className="w-full">
        <ServicesOverviewSection />
      </section>

      <section id="how-it-works" className="w-full">
        <HowItWorksSection />
      </section>
      
      <section id="analyzer" className="w-full">
        <UrlAnalyzerTool />
      </section>

      <section id="optimization" className="w-full">
        <AllPackagesSection />
      </section> 

      <section id="faq" className="w-full">
        <FaqSection />
      </section>
      
      <ContactFormPopup />

    </div>
  );
}
